<template>
  <Tooltip :title="ariaLabel" :delay="300" :disableClosingTrigger="true">
    <Component
      :is="asChild ? ToggleGroupItem : Toggle"
      :pressed="pressed"
      :aria-label="ariaLabel"
      :class="cn(variants({ size, intermediate }))"
      :disabled="disabled"
      :asChild="asChild"
      :defaultValue="defaultValue"
      @update:pressed="(val) => toggle(val)"
    >
      <slot />
    </Component>
  </Tooltip>
</template>

<script setup>
import { ref, watch } from "vue";
import { Toggle, ToggleGroupItem } from "radix-vue";
import { Tooltip } from "@/SharedComponents/Tooltips";
import { sizes, variants } from ".";
import { cn } from "@/Utils/cn";

const emit = defineEmits(["update:pressed"]);

const props = defineProps({
  pressed: { type: Boolean, required: false, default: false },
  ariaLabel: { type: String, required: false, default: "" },
  asChild: { type: Boolean, required: false },
  disabled: { type: Boolean, required: false, default: false },
  defaultValue: { type: Boolean, required: false, default: false },
  intermediate: { type: Boolean, required: false, default: false },
  size: {
    type: String,
    validator: (val) => sizes.includes(val),
    required: false,
    default: "sm",
  },
});

const pressed = ref(props.pressed);

watch(
  () => props.pressed,
  (value) => {
    pressed.value = value;
  }
);

const toggle = (value) => {
  pressed.value = value;
  emit("update:pressed", value);
};
</script>
